import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import { isDataNew, type ReviewCellRendererProps } from '../helpers';
import { Icon, type OptionType, TriggerableMenu } from 'venn-ui-kit';
import { DataUploaderMode } from '../../../types';
import { convertToTriggerableMenuOption, performMappingUpdate } from './rendererHelpers';

export const ActionCellRenderer = (props: ICellRendererParams & ReviewCellRendererProps) => {
  const { data, metadata, mode } = props;
  const { fundId, portfolioNodeId } = data;
  const isReturns = mode === DataUploaderMode.Returns;
  const isNew = isDataNew(isReturns, !!fundId, !!portfolioNodeId);
  const actionOptions = metadata.appendType.map(convertToTriggerableMenuOption);
  const selectedOption = actionOptions.find((o) => o.value === data.appendId)?.label;

  return (
    <div className="py-[8px] text-[12px] text-venn-black leading-[16px]">
      {isNew ? (
        'Create new investment'
      ) : (
        <TriggerableMenu
          usePortal
          options={actionOptions}
          innerClassName="mt-[19px] max-h-fit"
          className="!min-h-[16px] font-bold text-venn-dark-blue cursor-pointer"
          onSelect={(selectedOption: OptionType<string | number>) => {
            const values = isNew
              ? [selectedOption.value, data.currency, data.typeId]
              : isReturns
                ? [selectedOption.value, data.currency, data.typeId]
                : [];
            performMappingUpdate(props, values);
          }}
        >
          {selectedOption ?? '--'}
          <Icon type="chevron-down" className="ml-[4px]" />
        </TriggerableMenu>
      )}
    </div>
  );
};
